// saga.ts
import { call, put, takeEvery } from 'redux-saga/effects';
import { createCustomer, deleteCustomer, getCustomerApi, updateCustomer } from '../../api/CustomerApi'; // Adjust the path as needed
import {
    getCustomerSuccess,
    getCustomerFailure,
    createCustomerSuccess,
    createCustomerFailure,
    updateCustomerSuccess,
    updateCustomerFailure,
    deleteCustomerSuccess,
    deleteCustomerFailure,
} from './actions';

// Saga to handle fetching Customers
function* fetchCustomerSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(getCustomerApi, action.payload);
        yield put(getCustomerSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(getCustomerFailure(errorMessage));
    }
}

// // Saga to handle creating a Customer
function* createCustomerSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(createCustomer, action.payload);
        yield put(createCustomerSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(createCustomerFailure(errorMessage));
    }
}

// // Saga to handle updating a Customer
function* updateCustomerSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(updateCustomer, action.payload.data, action.payload.id);
        yield put(updateCustomerSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';

        yield put(updateCustomerFailure(errorMessage));
    }
}

// // Saga to handle updating a Customer
function* deleteCustomerSaga(action: any): Generator<any, any, any> {
    try {
        const data = yield call(deleteCustomer, action.payload.id);
        yield put(deleteCustomerSuccess(data));
    } catch (error: any) {
        const errorMessage = error?.response?.data?.meta?.message
            ? error.response
            : error?.message
            ? error.message
            : 'An unexpected error occurred';
        yield put(deleteCustomerFailure(errorMessage));
    }
}

export default function* CustomerSaga() {
    yield takeEvery('GET_CUSTOMER_REQUEST', fetchCustomerSaga);
    yield takeEvery('CREATE_CUSTOMER_REQUEST', createCustomerSaga);
    yield takeEvery('UPDATE_CUSTOMER_REQUEST', updateCustomerSaga);
    yield takeEvery('DELETE_CUSTOMER_REQUEST', deleteCustomerSaga);
}
